export const invalidValueMessageId = (fieldId: string) => `validation-error-${fieldId}`
